import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuardService } from './shared/services/authentication-guard/authentication-guard.service';
import { AdminOnlyGuard } from './shared/services/authentication-guard/admin-only.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/admin/login/login').then(m => m.AdminLogin),
  },
  {
    path: '',
    canActivate: [AuthenticationGuardService, AdminOnlyGuard],
    canActivateChild: [AdminOnlyGuard],
    loadComponent: () => import('./features/admin/layout/layout').then(m => m.AdminLayout),
    children: [
      {
        path: '',
        loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
